if ( typeof LocalizationForm !== 'function' ) {

  class LocalizationForm extends HTMLElement {

    constructor() {

      super();

      this.selector = this.querySelector('[data-js-localization-form-button]');
      this.content = this.querySelector('[data-js-localization-form-content]');
      // Store original parent reference for reattachment on mobile
      this.originalParent = null;

      // Removed the code block that was replacing the selector's innerHTML.
      // We want to use the earth icon defined in the mobile-only markup,
      // so we do not override it here.
      /*
      if ( window.innerWidth < 768 && this.selector && !this.classList.contains('mobile-only') ) {
        if ( this.querySelector('[data-js-localization-form-insert-helper-content]') ) {
          // This is assumed to be the currency selector.
          this.selector.innerHTML = '<img src="https://i.imghippo.com/files/iyZ9926EQk.png" alt="Currency" style="max-width:100%;"/>';
        } else {
          // Otherwise, assume it is the language selector.
          this.selector.innerHTML = '<img src="https://i.ibb.co/BKs8wHNx/language.png" alt="Language" style="max-width:100%;"/>';
        }
      }
      */

      // If helper content is used (typically on the currency selector), load it once.
      // Also auto-trigger populate() on mobile.
      if ( this.querySelector('[data-js-localization-form-insert-helper-content]') ) {
        if ( window.innerWidth < 768 ) {
          this.classList.add('populate');
          this.populate();
        } else {
          this.selector.addEventListener('click', e => {
            if ( ! this.classList.contains('populated') ) {
              this.classList.add('populate');
              this.populate();
            }
          });
        }
      }

      // Use our own toggle methods for opening/closing.
      this.selector.addEventListener('click', e => {
          e.stopPropagation();
          e.preventDefault();

          // Close any other open localization forms on the page.
          document.querySelectorAll('localization-form').forEach(form => {
            // Ensure we’re not closing the current instance.
            if (form !== this && form.content && form.content.classList.contains('content-opened')) {
              form.closeDropdown();
            }
          });

          // Toggle current dropdown.
          if ( this.content.classList.contains('content-opened') ) {
            this.closeDropdown();
          } else {
            this.openDropdown();
          }
      });

      this.querySelector('[data-js-localization-form-button]').addEventListener('keydown', function(e) {
        if ( e.keyCode === window.KEYCODES.RETURN ) {
          if ( ! this.content.classList.contains('opened-with-tab') ) {
            this.content.classList.add('opened-with-tab');
            this.content.querySelectorAll('[data-js-localization-form-item]').forEach(elm => {
              elm.setAttribute('tabindex', '0');
            });
          }
        }
      });
    }

    openDropdown() {
      // --- CUSTOMIZATION: Reparent dropdown on mobile ---
      if ( window.innerWidth < 768 ) {
        if ( !this.originalParent ) {
          this.originalParent = this.content.parentNode;
        }
        document.body.appendChild(this.content);
        const rect = this.selector.getBoundingClientRect();
        this.content.style.position = 'fixed';
        this.content.style.top = rect.bottom + 'px';
        this.content.style.left = '50%';
        this.content.style.transform = 'translateX(-50%)';
        // TASK 2: Reduce the dropdown width on mobile.
        this.content.style.width = '80%';
      }
      // --- END CUSTOMIZATION ---
      
      this.content.classList.add('content-opened');
      this.selector.setAttribute('aria-expanded', 'true');
      this.content.parentNode.style.zIndex = 1000;
      
      if ( this.content.getBoundingClientRect().y + this.content.offsetHeight + 55 > window.innerHeight ) {
        this.content.classList.add('invert-y');
      }
      if ( this.content.getBoundingClientRect().x + this.content.offsetWidth + 55 > window.innerWidth ) {
        this.content.classList.add('invert-x');
      }
      
      // Add a global click listener to close when clicking outside.
      this.onClickHandler = e => {
        // If the click is outside of our selector and content, close.
        if ( !this.contains(e.target) ) {
          this.closeDropdown();
        }
      };
      window.addEventListener('click', this.onClickHandler);
    }

    closeDropdown() {
      this.content.classList.remove('content-opened', 'invert-x', 'invert-y');
      this.content.parentNode.style.zIndex = 9;
      
      // --- CUSTOMIZATION: Reattach dropdown on mobile ---
      if ( window.innerWidth < 768 && this.originalParent ) {
        this.originalParent.appendChild(this.content);
        this.content.style.position = '';
        this.content.style.top = '';
        this.content.style.left = '';
        this.content.style.transform = '';
        this.content.style.width = '';
      }
      // --- END CUSTOMIZATION ---
      
      this.selector.setAttribute('aria-expanded', 'false');
      window.removeEventListener('click', this.onClickHandler);
    }

    populate() {
      fetch('?section_id=helper-localization-form').then(response => response.text())
        .then(text => {
          const results = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-helper-localization-form').innerHTML;
          this.querySelector('[data-js-localization-form-insert-helper-content]').innerHTML = results;
          
          // --- CUSTOMIZATION: After helper content loads, reparent on mobile ---
          if ( window.innerWidth < 768 ) {
            if ( !this.originalParent ) {
              this.originalParent = this.content.parentNode;
            }
            document.body.appendChild(this.content);
            const rect = this.selector.getBoundingClientRect();
            this.content.style.position = 'fixed';
            this.content.style.top = rect.bottom + 'px';
            this.content.style.left = '50%';
            this.content.style.transform = 'translateX(-50%)';
            // TASK 2: Also reduce the width here.
            this.content.style.width = '80%';
          }
          // --- END CUSTOMIZATION ---
          
          if ( this.content.getBoundingClientRect().y + this.content.offsetHeight + 55 > window.innerHeight ) {
            this.content.classList.add('invert-y');
          }
          if ( this.content.getBoundingClientRect().x + this.content.offsetWidth + 55 > window.innerWidth ) {
            this.content.classList.add('invert-x');
          }
        })
        .catch(e => {
          console.log(e);
        });
    }

  }

  if ( typeof customElements.get('localization-form') == 'undefined' ) {
    customElements.define('localization-form', LocalizationForm);
  }
}
